const PRICE_TOLERANCE = 0.25;

export const PROMOTED_MODEL_CTA_TEXT = "View Diwali Offers"; // Seasonal copy; update here when the campaign changes.

// Keeps models within ±25% (inclusive) of the current starting price, minus the current model itself.
export const filterPromotedModels = (models: any[], currentModelId: string, currentPrice?: number | null) => {
    const basePrice = Number(currentPrice);
    if (!basePrice || basePrice <= 0) return [];
    return models.filter((m) => {
        const price = Number(m?.price_range?.base);
        return String(m?._id) !== String(currentModelId)
            && price > 0
            && Math.abs(price - basePrice) <= basePrice * PRICE_TOLERANCE;
    });
};
